/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Light_Plum_Ant_BoltInputs */

const en_light_plum_ant_bolt = /** @type {(inputs: Light_Plum_Ant_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete participation`)
};

const de_light_plum_ant_bolt = /** @type {(inputs: Light_Plum_Ant_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen der Teilnahme fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed to delete participation" |
*
* @param {Light_Plum_Ant_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_plum_ant_bolt = /** @type {((inputs?: Light_Plum_Ant_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Plum_Ant_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_plum_ant_bolt(inputs)
	return de_light_plum_ant_bolt(inputs)
});